/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */
import type { MutationFunction, QueryFunction, QueryKey, UseMutationOptions, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    FavoriteItem,
    IActionResult,
    NavigationItem,
    NavigationItemPreference,
    NavigationRecentSearches,
    ProblemDetails,
} from '../../model';
import type { ErrorType } from '../../utils/UseCustomInstance';
import { useCustomInstance } from '../../utils/UseCustomInstance';

export const useGetNavigationItemsHook = () => {
    const getNavigationItems = useCustomInstance<NavigationItem[]>();

    return (signal?: AbortSignal) => {
        return getNavigationItems({ url: `/Navigation`, method: 'get', signal });
    };
};

export const getGetNavigationItemsQueryKey = () => [`/Navigation`] as const;

export const useGetNavigationItemsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetNavigationItemsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNavigationItemsHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNavigationItemsHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetNavigationItemsQueryKey();

    const getNavigationItems = useGetNavigationItemsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetNavigationItemsHook>>>> = ({ signal }) =>
        getNavigationItems(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetNavigationItemsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetNavigationItemsHook>>>>;
export type GetNavigationItemsQueryError = ErrorType<ProblemDetails>;

export const useGetNavigationItems = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetNavigationItemsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNavigationItemsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetNavigationItemsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const usePutNavigationPreferenceItemHook = () => {
    const putNavigationPreferenceItem = useCustomInstance<IActionResult>();

    return (navigationItemPreference: NavigationItemPreference) => {
        return putNavigationPreferenceItem({
            url: `/Navigation`,
            method: 'put',
            headers: { 'Content-Type': 'application/json' },
            data: navigationItemPreference,
        });
    };
};

export const usePutNavigationPreferenceItemMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutNavigationPreferenceItemHook>>>,
        TError,
        { data: NavigationItemPreference },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutNavigationPreferenceItemHook>>>,
    TError,
    { data: NavigationItemPreference },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putNavigationPreferenceItem = usePutNavigationPreferenceItemHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePutNavigationPreferenceItemHook>>>,
        { data: NavigationItemPreference }
    > = (props) => {
        const { data } = props ?? {};

        return putNavigationPreferenceItem(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutNavigationPreferenceItemMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePutNavigationPreferenceItemHook>>>
>;
export type PutNavigationPreferenceItemMutationBody = NavigationItemPreference;
export type PutNavigationPreferenceItemMutationError = ErrorType<ProblemDetails>;

export const usePutNavigationPreferenceItem = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutNavigationPreferenceItemHook>>>,
        TError,
        { data: NavigationItemPreference },
        TContext
    >;
}) => {
    const mutationOptions = usePutNavigationPreferenceItemMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useGetMruSearchesHook = () => {
    const getMruSearches = useCustomInstance<NavigationRecentSearches>();

    return (signal?: AbortSignal) => {
        return getMruSearches({ url: `/Navigation/navigationrecentsearch`, method: 'get', signal });
    };
};

export const getGetMruSearchesQueryKey = () => [`/Navigation/navigationrecentsearch`] as const;

export const useGetMruSearchesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetMruSearchesHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMruSearchesHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMruSearchesHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetMruSearchesQueryKey();

    const getMruSearches = useGetMruSearchesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMruSearchesHook>>>> = ({ signal }) => getMruSearches(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetMruSearchesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMruSearchesHook>>>>;
export type GetMruSearchesQueryError = ErrorType<ProblemDetails>;

export const useGetMruSearches = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetMruSearchesHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMruSearchesHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetMruSearchesQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useDeleteRecentSearchesHook = () => {
    const deleteRecentSearches = useCustomInstance<IActionResult>();

    return () => {
        return deleteRecentSearches({ url: `/Navigation/navigationrecentsearch`, method: 'delete' });
    };
};

export const useDeleteRecentSearchesMutationOptions = <
    TError = ErrorType<ProblemDetails>,
    TVariables = void,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteRecentSearchesHook>>>, TError, TVariables, TContext>;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteRecentSearchesHook>>>, TError, TVariables, TContext> => {
    const { mutation: mutationOptions } = options ?? {};

    const deleteRecentSearches = useDeleteRecentSearchesHook();

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteRecentSearchesHook>>>, TVariables> = () => {
        return deleteRecentSearches();
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteRecentSearchesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteRecentSearchesHook>>>>;

export type DeleteRecentSearchesMutationError = ErrorType<ProblemDetails>;

export const useDeleteRecentSearches = <TError = ErrorType<ProblemDetails>, TVariables = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteRecentSearchesHook>>>, TError, TVariables, TContext>;
}) => {
    const mutationOptions = useDeleteRecentSearchesMutationOptions(options);

    return useMutation(mutationOptions);
};
export const usePutNavigationSearchHook = () => {
    const putNavigationSearch = useCustomInstance<IActionResult>();

    return (navigationViewId: string) => {
        return putNavigationSearch({ url: `/Navigation/navigationrecentsearch/${navigationViewId}`, method: 'put' });
    };
};

export const usePutNavigationSearchMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutNavigationSearchHook>>>,
        TError,
        { navigationViewId: string },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutNavigationSearchHook>>>,
    TError,
    { navigationViewId: string },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putNavigationSearch = usePutNavigationSearchHook();

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutNavigationSearchHook>>>, { navigationViewId: string }> = (
        props
    ) => {
        const { navigationViewId } = props ?? {};

        return putNavigationSearch(navigationViewId);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutNavigationSearchMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutNavigationSearchHook>>>>;

export type PutNavigationSearchMutationError = ErrorType<ProblemDetails>;

export const usePutNavigationSearch = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutNavigationSearchHook>>>,
        TError,
        { navigationViewId: string },
        TContext
    >;
}) => {
    const mutationOptions = usePutNavigationSearchMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useGetFavoriteItemsHook = () => {
    const getFavoriteItems = useCustomInstance<FavoriteItem[]>();

    return (signal?: AbortSignal) => {
        return getFavoriteItems({ url: `/Navigation/favorites`, method: 'get', signal });
    };
};

export const getGetFavoriteItemsQueryKey = () => [`/Navigation/favorites`] as const;

export const useGetFavoriteItemsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetFavoriteItemsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFavoriteItemsHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFavoriteItemsHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetFavoriteItemsQueryKey();

    const getFavoriteItems = useGetFavoriteItemsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetFavoriteItemsHook>>>> = ({ signal }) =>
        getFavoriteItems(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetFavoriteItemsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetFavoriteItemsHook>>>>;
export type GetFavoriteItemsQueryError = ErrorType<ProblemDetails>;

export const useGetFavoriteItems = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetFavoriteItemsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFavoriteItemsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetFavoriteItemsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};
